{
  "aboutProject": "About project",
  "attachmentComment": "Comments on attachment",
  "attachmentName": "Name of attachment",
  "buisinessDescription": "Business description",
  "cannotChangeFinishedProject": "Completed projects cannot be changed.",
  "cantGetProjectTypes": "Couldn't load project types, reload the page and try again.",
  "causeOfProjectEnd": "Cause of ending",
  "changeMainGoal": "Change main goal",
  "changeMainGoalDescription": "You must explain why you wish to change this projects main goal. This will be added to the clusters yearly report.",
  "changeMainGoalWhy": "Why have you changed your main goal?",
  "changeProjectType": "Change project type",
  "changeType": "Change type",
  "changingMainGoal": "Change main goal",
  "changingTypeDeletesBudget": "Changing the project type will delete all budget data. You will get new cost types that have to be filled in. This choice cannot be undone.",
  "chooseCause": "Pick cause",
  "chooseMultiple": "(you can select multiple)",
  "chooseMultipleFocusAreas": "(you can select multiple focus areas)",
  "chooseProgression": "Choose progression",
  "clickHereToGo": "Click here to go to",
  "couldNotAddLeadToProject": "Could not add lead to project.",
  "couldNotCreateCategory": "Could not create new project category. Please try again.",
  "couldNotCreateProject": "Could not create project. Fix eventual errors and try again.",
  "couldNotDeleteProject": "Could not delete project, please try again.",
  "couldNotEditActivity": "Could not edit activity. Please try again.",
  "couldNotEndProject": "Could not end project. Please try again.",
  "couldNotUpdateProject": "Could not update project. Please try again.",
  "createActivity": "Create activity",
  "createProjectError": "An error occured when creating project. Check that all fields are validated and that a new project category does not have the same name as an already existing one.",
  "customCategories": "Custom categories",
  "customProjectCategoryName": "Custom category name",
  "deleteProject": "Delete project",
  "developmentProjects": "Development projects",
  "editActivity": "Edit activity",
  "educationalOfferingsDescriptionLabel": "Project content",
  "ended": "Ended",
  "endProject": "End project",
  "errorCode.Between1And5WhenEndCategoryIsCompleted": "Satisfaction rate must be between 1 and 5 when end category is 'completed'",
  "errorCode.CannotSetEndReasonWhenNotTerminated": "Cannot set project end reason without terminating the project",
  "errorCode.CategoryRequiredWhenNoType": "Project category is required when no type is specified",
  "errorCode.EndSubCategoryOnlySetWhenContinued": "Project end sub category should only be set when project end category is 'continued'",
  "errorCode.EndSubCategoryRequiredWhenContinued": "Project end sub category must be set when project end category is 'continued'",
  "errorCode.SatisfactionRateShouldOnlyBeSetWhenCompleted": "Satisfaction rate should only be set when end category is 'completed'",
  "errorCode.SourceCodeMustBeApplicationCrmOrPortal": "Project source must be Application, CRM or Portal",
  "explainProjectProgression": "Explain what the project was progressed to",
  "focusAreas": "Focus areas",
  "goalDescriptionLabel": "Expected results and effect goals",
  "goToProjects": "Go to projects",
  "inFinancedProjects": "projects financed by Innovation Norway",
  "inFinancedProjectsDescription": "Here are your projects financed by Innovation Norway, these are fetched from your applications.",
  "justificationLabel": "Background",
  "mainGoal": "Main goal",
  "missingProjectCategory": "When choosing project category Other you must enter a name for the project category.",
  "missingStartOrEndDate": "The project is missing a valid start or end date.",
  "mission": "Mission",
  "newActivity": "New activity",
  "noInFinancedProjects": "You have no projects financed by Innovation Norway. Projects you send applications for will appear here.",
  "noneSelected.removeParticipant": "You have to mark aleast one row to remove a participant.",
  "noOwnProjects": "You have no own projects, these can be created in the portal.",
  "numberOfEvents": "Number of events",
  "onlyChooseOne": "(you can only select one cluster goal)",
  "otherProjects": "Other projects",
  "ownProjects": "own projects",
  "PEC01": "Cancelled",
  "PEC02": "Completed",
  "PEC03": "Transferred",
  "portalProjectsDescription": "Here are your projects created in the portal.",
  "predefinedCategories": "Predefined categories",
  "project": "Project",
  "projectCategories": "Project categories",
  "projectCategoryAlreadyExists": "A new project category with this name already exists.",
  "projectDeleteWarning": "Are you sure you want to delete this project? Any created events and corresponding In-kind will be deleted.",
  "projectDescription": "Project description",
  "projectLeader": "Project leader",
  "projectMissingType": "This project is missing a project type",
  "projectName": "Project name",
  "projects": "Projects",
  "projectsDescription": "The projects that are registered can be organized by the cluster or the cluster members. The purpose of registering the projects that are carried out in the cluster is to give the cluster management an overview of the activities that take place in the cluster.",
  "projectsPerPage": "Projects per page",
  "projectType": "Project type",
  "rateProjectSuccess": "To what extent would you rate the project as successful?",
  "registeredHours": "Registered hours",
  "searchMainGoal": "Seach main goal",
  "searchSubProject": "Seach subproject",
  "seeINProjects": "To see projects financed by IN go to ",
  "seeOtherProjects": "To see other projects go to the overview of your ",
  "selectFocusAreas": "Select focus areas",
  "selectGoal": "Select goal",
  "selectProject": "Select project",
  "selectProjectCategory": "Select project category",
  "selectSocietalAndEnvironmentalEffects": "Select societal and environmental effect",
  "selectType": "Select type",
  "societalAndEnvironmentalEffects": "Societal and environmental effects",
  "subproject": "Subproject",
  "subProjects": "Subprojects",
  "toAGreatExtent": "To a great extent",
  "toASmallExtent": "To a small extent",
  "trainingDescriptionLabel": "\nContent of the training project",
  "typeChangedTo": "Project type changed to {{newType}}",
  "uniqueParticipants": "Unique participants",
  "vision": "Vision",
  "visionAndMission": "Vision & mission",
  "whatWasProjectProgressedTo": "What was the project progressed to?",
  "whatWasResultOfProject": "What was the result of the project?",
  "whyProjectedEnded": "Why was the project ended?",
  "noCompaniesSelected": "No companies selected"
}
